export type SubscriptionModalVariant = "guest" | "free_trial" | "subscription";

export const getSubscriptionModalVariant = (
  isGuestAccount: boolean,
  isFreeTrialAvailable: boolean
): SubscriptionModalVariant => {
  if (isGuestAccount) return "guest";
  if (isFreeTrialAvailable) return "free_trial";
  return "subscription";
};
